import styled from "styled-components";

export const ModalContainer = styled.div`
  background: #0a0b0c;
  border-radius: 24px;
  border: 1px solid #18181b;
  padding: 24px;
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const PromptModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PromptModalTitle = styled.h3`
  font-family: "DM Sans", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0;
`;

export const PromptInputTitle = styled.h3`
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 500;
  color: #fff;
`;

export const PromptInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PromptCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PromptTextarea = styled.textarea`
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;

  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #2877d9;
  }

  &::placeholder {
    color: #666;
  }
`;

export const PromptSeedInput = styled.input`
  width: 100%;

  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;

  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.21px;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #2877d9;
  }

  &::placeholder {
    color: #666;
  }
`;

export const PromptModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const PromptCancelButton = styled.button`
  padding: 10px 24px;
  background: transparent;
  border: 1px solid #333;
  border-radius: 8px;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #2a2a2a;
    border-color: #444;
  }
`;

export const PromptSubmitButton = styled.button`
  padding: 10px 24px;
  background: #2877d9;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #2877d995;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const VideoQualityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VideoQualityItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 8px;
  align-items: center;
  border-radius: 12px;
  background: #111113;
  height: 33px;
`;

export const VideoQualityCheckboxContainer = styled.div`
  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? "none" : "auto")};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.3 : 1)};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const VideoQualityTitle = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
`;

export const VideoQualityText = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const VideoQualityDescription = styled.p`
  color: #fff;
  font-family: DM Sans;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.5;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: 10px;
`;

export const LockContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const ProOnly = styled.p`
  color: #4d9dff;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 500;
  padding-left: 5px;
`;

// FPS Slider Styles
export const FpsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FpsTitle = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const FpsSlider = styled.input`
  width: 100%;
  height: 10px;
  border-radius: 12px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  background: linear-gradient(
    to right,
    #366db1 0%,
    #366db1 ${({ value, min, max }) => ((value - min) / (max - min)) * 100}%,
    #18181b ${({ value, min, max }) => ((value - min) / (max - min)) * 100}%,
    #18181b 100%
  );

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border: none;
    transition: all 0.2s ease;
    outline: 10px solid transparent;
  }

  &::-webkit-slider-thumb:active {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(40, 119, 217, 0.5);
    outline: 3px solid rgba(255, 255, 255, 0.25);
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease;
  }

  &::-moz-range-thumb:active {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(40, 119, 217, 0.5);
  }

  &::-moz-range-track {
    background: transparent;
    border: none;
  }

  &::-moz-range-progress {
    background: #366db1;
  }
`;

export const FpsLabels = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const FpsLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  opacity: 0.5;
  font-weight: 600;
  letter-spacing: -0.195px;
`;
